import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { PresetManagerWrap, RowContentWrap, ImportWrap, EditWrap, EditActions, ImportBoxWrap, ImportRowButtons } from "../styles";
import { Button, ButtonGroup, Select, HorizontalLayout } from "../../BaseComponents";
import { ImportTool } from "../../ImportTool";
import { Popconfirm } from "antd";
import { ModuleInputs, InverterInputs, RackingInputs, PerformanceInputs, WeatherInputs, LayoutInputs, FinanceInputs, UserActions, inputsActions, usePrevious, create_UUID, siftActions } from "../..";
import { inputsInitialState } from "../../Redux/_reducers/sift_inputs";
import { pick } from "../..";
import { getInputKeys } from "../../../_Schemas";

const GetPresetPanel = (type, inputs) => {
  switch (type) {
    case "module":
      return <ModuleInputs />;
    case "racking":
      return <RackingInputs inputs={inputs} />;
    case "inverter":
      return <InverterInputs inputs={inputs} />;
    case "performance":
      return <PerformanceInputs inputs={inputs} />;
    case "weather":
      return <WeatherInputs inputs={inputs} />;
    case "inverter":
      return <LayoutInputs inputs={inputs} />;
    case "finance":
      return <FinanceInputs inputs={inputs} />;
    default:
      return null;
  }
};

const preset_aliases = [
  {
    header_name: "Modules",
    preset_name: "module",
    name: "mod_name",
    id: "mod_id",
    can_import: true,
  },
  {
    header_name: "Inverters",
    preset_name: "inverter",
    name: "inv_name",
    id: "inv_id",
    can_import: true,
  },
  {
    header_name: "Racking",
    preset_name: "racking",
    name: "racking_name",
    id: "racking_id",
    can_import: false,
  },
  // {
  //   header_name: "Weather",
  //   preset_name: "weather",
  //   name: "weather_name",
  //   id: "weather_id",
  //   can_import: true,
  // },
  {
    header_name: "Performance",
    preset_name: "performance",
    name: "perf_name",
    id: "perf_id",
    can_import: false,
  },
  {
    header_name: "Finance",
    preset_name: "finance",
    name: "finance_name",
    id: "finance_id",
    can_import: false,
  },
  {
    header_name: "Layout",
    preset_name: "layout",
    name: "layout_name",
    id: "layout_id",
    can_import: false,
  },
];

const name_map = {
  module: "mod_name",
  inverter: "inv_name",
};

const id_map = {
  module: "mod_id",
  inverter: "inv_id",
  racking: "racking_id",
  performance: "perf_id",
  finance: "finance_id",
  layout: "layout_id",
};

const PresetManager = () => {
  const dispatch = useDispatch();

  const presets = useSelector((state) => state.user.presets);
  const user_group_defaults = useSelector((state) => state.user.user_group_defaults);
  const inputs = useSelector((state) => state.inputs);

  const user_group = useSelector((state) => state.user.user_group);

  const import_loading = useSelector((state) => state.sift.ioManager.uiState.import_loading);
  const import_loading_prev = usePrevious(import_loading);

  const [local_presets, set_local_presets] = useState();
  const [preset_vars, set_preset_vars] = useState();
  const [open_row_content, set_open_row_content] = useState({});
  const [selected_defaults, set_selected_defaults] = useState({});

  useEffect(() => {
    if (import_loading_prev === true && import_loading === false) {
      const name_of_imported_preset = Object.keys(open_row_content)[0];
      const tempKeys = getInputKeys(name_of_imported_preset);
      const inputs_for_preset = pick(inputs, tempKeys);

      const id = create_UUID();
      const name = inputs_for_preset[name_map[name_of_imported_preset]];

      set_selected_defaults((prevState) => ({
        ...prevState,
        [name_of_imported_preset]: { id, name },
      }));

      set_preset_vars((prevState) => ({
        ...prevState,
        [name_of_imported_preset]: inputs_for_preset,
      }));
    }
  }, [import_loading]);

  // useEffect(() => {
  //   console.log("preset vats", preset_vars);
  // }, [preset_vars]);

  useEffect(() => {
    const clonedPresets = JSON.parse(JSON.stringify(presets));
    const newDefaults = {};

    preset_aliases.forEach((item) => {
      clonedPresets[item.preset_name] = clonedPresets[item.preset_name].filter((preset) => preset[item.id] !== "simple_inv" && preset[item.id] !== "simple_mod");
    });

    preset_aliases.forEach((item) => {
      clonedPresets[item.preset_name].forEach((preset) => {
        preset["name"] = preset[item.name];
        preset["type"] = item.preset_name;
        preset["id"] = preset[item.id];

        const userDefault = user_group_defaults[item.preset_name];

        const matchesUuid = userDefault === preset?.uuid;
        const matchesId = userDefault === preset?.[item.id];

        const defaultId = typeof userDefault === "object" ? userDefault?.id : userDefault;

        if (defaultId === preset[item.id] || matchesUuid || matchesId) {
          newDefaults[item.preset_name] = {
            id: preset[item.id],
            name: preset[item.name] || "Search",
          };
        } else if (!defaultId) {
          newDefaults[item.preset_name] = { id: "", name: "Search" };
          set_preset_vars((prevState) => {
            const newState = { ...prevState };
            delete newState[item.preset_name];
            return newState;
          });
        }
      });

      // Fallback in case no preset matched or was added
      if (!newDefaults[item.preset_name]) {
        newDefaults[item.preset_name] = { id: "", name: "Search" };
        set_preset_vars((prevState) => {
          const newState = { ...prevState };
          delete newState[item.preset_name];
          return newState;
        });
      }
    });

    set_selected_defaults(newDefaults);
    set_local_presets(clonedPresets);
  }, [presets, user_group_defaults]);

  // useEffect(() => {
  //   const clonedPresets = JSON.parse(JSON.stringify(presets));
  //   const newDefaults = {};

  //   preset_aliases.forEach((item) => {
  //     clonedPresets[item.preset_name] = clonedPresets[item.preset_name].filter((preset) => preset[item.id] !== "simple_inv" && preset[item.id] !== "simple_mod");
  //   });

  //   preset_aliases.forEach((item) => {
  //     clonedPresets[item.preset_name].forEach((preset) => {
  //       preset["name"] = preset[item.name];
  //       preset["type"] = item.preset_name;
  //       preset["id"] = preset[item.id];

  //       if (user_group_defaults[item.preset_name] === preset?.uuid || user_group_defaults[item.preset_name] === preset[item.id]) {
  //         newDefaults[item.preset_name] = { id: preset[item.id], name: preset[item?.name] };
  //       } else {
  //         newDefaults[item.preset_name] = { id: "", name: "Search" };
  //       }
  //     });
  //   });

  //   set_selected_defaults(newDefaults);
  //   set_local_presets(clonedPresets);
  // }, [presets, user_group_defaults]);

  const handleSelectChange = (e) => {
    set_preset_vars((prevState) => ({
      ...prevState,
      [e.target.value.type]: e.target.value,
    }));
  };

  const handleOpenRowContent = (preset_name, toolType) => {
    set_open_row_content((prevState) => ({
      ...prevState,
      [preset_name]: prevState[preset_name] === toolType ? null : toolType,
    }));
  };

  const handlePresetAction = (item, reset_default = false, delete_preset = false) => {
    const presetName = item?.preset_name;
    if (!presetName) return;

    let presetInputs = reset_default ? null : preset_vars?.[presetName];

    if (reset_default) {
      const tempKeys = getInputKeys(presetName);
      const inputsToBeReset = pick(inputsInitialState, tempKeys);
      presetInputs = Object.fromEntries(Object.entries(inputsToBeReset).filter(([_, val]) => val !== undefined));
    }

    if (!presetInputs) return;

    const { id, ...cleanedInputs } = presetInputs;
    const group = Object.values(user_group)[0];
    const isRacking = presetName === "racking";
    const presetId = reset_default ? "" : isRacking ? presetInputs.uuid || presetInputs.racking_id : presetInputs.id;

    const userGroupData = {
      group_id: group.group_id,
      user_id: group.user_id,
      type: presetName,
      id: presetId,
    };

    const preset_already_stored = presets[userGroupData.type].some(
      (preset) => (presetName === "racking" && preset.uuid == userGroupData.id) || preset[id_map[userGroupData.type]] === userGroupData.id
    );

    if (delete_preset) {
      if (id === user_group_defaults[item.presetName]) {
        dispatch(alertActions.info(`This is your group's current default ${tab} and cannot be deleted.`, 4));
        return;
      }
      cleanedInputs.delete = "delete";
      dispatch(siftActions.saveInput(cleanedInputs, userGroupData.type, "delete", item.id));
    } else {
      if (preset_already_stored || reset_default) {
        dispatch(UserActions.updateUserGroupdefaults(userGroupData));
        dispatch(inputsActions.update_bulk_inputs(cleanedInputs));
      } else {
        // dispatch(siftActions.saveInput(cleanedInputs, userGroupData.type, "save", item.id, true, { group_id: group.group_id, user_id: group.user_id, type: presetName }));
      }
    }
  };

  if (!local_presets) return null;

  return (
    <PresetManagerWrap>
      {preset_aliases.map((item) => (
        <section key={item.header_name}>
          <section className="preset-row">
            <p>{item.header_name}</p>
            <Select
              defaultValue={selected_defaults?.[item?.preset_name]}
              key={item.preset_name}
              style={{ maxWidth: "200px" }}
              searchable={true}
              options={local_presets[item.preset_name]}
              onChange={handleSelectChange}
            />
            <ButtonGroup>
              {item.can_import && (
                <Button
                  size="small"
                  label="Import"
                  id={item.preset_name}
                  disabled={!item.can_import}
                  tooltip={item.can_import ? null : "Import not available"}
                  onClick={() => handleOpenRowContent(item.preset_name, "import")}
                />
              )}
              <Popconfirm
                title={
                  <>
                    Delete <strong>{preset_vars?.[item.preset_name]?.name}</strong> from your presets?
                  </>
                }
                onConfirm={() => handlePresetAction(item, false, true)}
              >
                <Button size="small" label="Delete" id={item.preset_name} disabled={!preset_vars?.[item.preset_name]} tooltip={!preset_vars?.[item.preset_name] ? "No Preset selected" : null} />
              </Popconfirm>
            </ButtonGroup>
            <section className="preset-action-btn">
              <Popconfirm
                title={
                  <>
                    Set <strong>{preset_vars?.[item.preset_name]?.name}</strong> as your Group's default {item.preset_name}
                  </>
                }
                onConfirm={() => handlePresetAction(item)}
              >
                <Button
                  key={`${item.preset_name}_btn`}
                  id={item.preset_name}
                  disabled={!preset_vars?.[item.preset_name]}
                  type="secondary"
                  size="small"
                  label="Set Group Default"
                  // onClick={() => handleOpenRowContent(item.preset_name, "share_with_group")}
                  // onClick={() => handlePresetAction(item)}
                />
              </Popconfirm>
              <Popconfirm
                title={
                  <>
                    Reset your <strong>{item.preset_name}</strong> to SIFT's original default?
                  </>
                }
                onConfirm={() => handlePresetAction(item, true)}
              >
                <Button key={`${item.preset_name}_reset_btn`} id={item.preset_name} disabled={!user_group_defaults[item.preset_name]} type="secondary" size="small" label="Reset Default" />
              </Popconfirm>
            </section>
          </section>
          <RowContentWrap open={open_row_content[item.preset_name]}>
            {/* {preset_vars?.[item?.preset_name] && open_row_content[item.preset_name] === "share_with_group" && (
              <ShareWrap>
                <section className="share-content">
                  <p>{`Would you like to make ${preset_vars[item.preset_name].name} the default ${item.preset_name} for your group?`}</p>
                  <section className="share-btns">
                    <Button size="small" type="secondary" label="Yes, make it the default" onClick={() => handleSetPresetDefault(item)} />
                    <Button size="small" type="secondary" label="No, just share with my group" onClick={() => console.log("sharing with group")} />
                  </section>
                </section>
              </ShareWrap>
            )} */}
            {item.can_import && open_row_content[item.preset_name] === "import" && (
              <ImportBoxWrap>
                <ImportRowButtons>
                  <Button size="small" type="ghost" icon={"CloseOutlined"} onClick={() => handleOpenRowContent(item.preset_name, "import")} />
                </ImportRowButtons>
                <ImportWrap>
                  <ImportTool definedType={item.preset_name} />
                </ImportWrap>
              </ImportBoxWrap>
            )}
            {/* {open_row_content[item.preset_name] === "edit" && preset_vars[item.preset_name] && GetPresetPanel(item.preset_name, preset_vars[item.preset_name])} */}
            {open_row_content[item.preset_name] === "edit" && preset_vars[item.preset_name] && (
              <EditWrap key={`${item.preset_name}_edit`}>
                <EditActions>
                  <h3>{`${preset_vars[item.preset_name].name}`}</h3>
                  <HorizontalLayout>
                    <Button size="small" type="ghost" label="Save Changes" />
                    <Button size="small" type="ghost" icon={"CloseOutlined"} onClick={() => handleOpenRowContent(item.preset_name, "edit")} />
                  </HorizontalLayout>
                </EditActions>
                {GetPresetPanel(item.preset_name, preset_vars[item.preset_name])}
              </EditWrap>
            )}
          </RowContentWrap>
        </section>
      ))}
    </PresetManagerWrap>
  );
};

export { PresetManager };
